import CRUDService, {ItemValue} from './CRUDService';

export interface HallwayMonitorResponse {
  userId: string;
  userType: string;
  demo: boolean;
  deleted: boolean;
  canImpersonateUser: boolean;
  valid: boolean | null;
  attributes: string;
  showVerifyEmailButton: boolean;
  showAccountConversionButton: boolean;
  invalidErrorMessages: string[];
}

export interface RepairOption {
  key: string;
  label: string;
  description: string;
  details: Record<string, unknown>[];
}

export interface UserRepairInspectionResponse {
  repairs: RepairOption[];
  valid: boolean;
}

export default class AdminActionsService {
  static service = new CRUDService('/admin');

  static hallwayMonitor(query: string): Promise<HallwayMonitorResponse> {
    return this.service.custom<HallwayMonitorResponse>('hallway-monitor', {q: query});
  }

  static deleteUser(userId: string, reason: string): Promise<Record<string, never>> {
    return this.service.destroy('delete-user', {d: userId, reason});
  }

  static triggerEvaluation(studentId: string): Promise<ItemValue> {
    return this.service.create({studentId}, {}, '/admin/trigger-evaluation');
  }

  static restoreUser(userId: string, email: string): Promise<ItemValue> {
    return this.service.create({userId, email}, {}, '/admin/restore-user');
  }

  static verifyUserEmail(userId: string): Promise<ItemValue> {
    return this.service.create({}, {q: userId}, '/admin/verify-user-email');
  }

  static revertConversion(userId: string): Promise<ItemValue> {
    return this.service.create({}, {user_id: userId}, '/admin/revert-conversion');
  }

  static updateDemoStatus(studentId: string, demoStatus: boolean): Promise<ItemValue> {
    return this.service.create({studentId, demoStatus}, {}, '/admin/update-demo-status');
  }

  static userRepairInspection(userId: string): Promise<UserRepairInspectionResponse> {
    return this.service.custom<UserRepairInspectionResponse>('user-repair-inspection', {userId});
  }

  static async repairUser(userId: string, repairKey: string): Promise<void> {
    await this.service.create({userId, repairKey}, {}, '/admin/repair-user');
  }
}
